import { AddressLookupSelectedAddress } from '@eventr/common'
import { AddressLookup } from '@eventr/common-storybook'
import { useMemo } from 'react'
import { Control, Controller } from 'react-hook-form'
import { gwApiClient } from '../../../data/apiClients'
import i18n from '../../../i18n/i18next'
import { bs } from '../../../state/bound.store'
interface IFormAddressInputProps {
    isGeneralInfo?: boolean
    control: Control
    name?: string
    fieldLabel?: string
}
export const FormAddressInput = ({
    isGeneralInfo,
    control,
    name,
    fieldLabel,
}: IFormAddressInputProps) => {
    const itinOSMAddress: AddressLookupSelectedAddress | null = useMemo(() => {
        if (isGeneralInfo) return null
        if (bs().getEventInfoV2().data.OSMAddress) {
            return bs().getEventInfoV2().data.OSMAddress
        } else {
            return null
        }
    }, [isGeneralInfo])
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                return (
                    <AddressLookup
                        selectedAddress={value}
                        setSelectedAddress={onChange}
                        addressLabels={{
                            manually: i18n.t(
                                'edit-itinerary.fields.address-lines.manual'
                            ),
                            use_lookup: i18n.t(
                                'edit-itinerary.fields.address-lines.look-up'
                            ),
                            placeholder: i18n.t(
                                'edit-itinerary.fields.address-lines.placeholder'
                            ),
                            town: i18n.t(
                                'edit-itinerary.fields.address-lines.town'
                            ),
                            country: i18n.t(
                                'edit-itinerary.fields.address-lines.country'
                            ),
                            line1: i18n.t(
                                'edit-itinerary.fields.address-lines.line1'
                            ),
                            line2: i18n.t(
                                'edit-itinerary.fields.address-lines.line2'
                            ),
                            postcode: i18n.t(
                                'edit-itinerary.fields.address-lines.postcode'
                            ),
                            clearButtonText: i18n.t(
                                'edit-itinerary.fields.clearButtonText'
                            ),
                            noTimezoneFound: i18n.t(
                                'edit-itinerary.fields.noTimezoneFound'
                            ),
                        }}
                        apiClient={gwApiClient as any}
                        label={fieldLabel}
                        useTzAsCenter={isGeneralInfo}
                        centerAround={
                            !itinOSMAddress
                                ? undefined
                                : {
                                      lat: Number(itinOSMAddress.lat),
                                      lon: Number(itinOSMAddress.lon),
                                  }
                        }
                        setTzOnSelect={isGeneralInfo}
                        isMobile
                    />
                )
            }}
        />
    )
}
